import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { AiConnectorComponent } from 'src/app/care/scenarios/quick-replies-commons/ai-connector/ai-connector.component';

downgradedAngularModule
  .directive('angularAiConnector', downgradeComponent({ component: AiConnectorComponent }));
